import selectInsurance from 'utils/selectInsurance';
import getPatientPhone1 from 'utils/print/getPatientPhone1';

const getInsuranceInsuredsPhone1 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  if (selectedInsuranceRelationToInsured === 'Self') {
    return getPatientPhone1({
      ...otherProps,
      patient,
      insurance,
    });
  }

  return null;
};

export default getInsuranceInsuredsPhone1;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsPhone1.js